import React from 'react';
import ScrollProgress from '../../components/landing/ScrollProgress';
import HeroSection from '../../components/landing/HeroSection';
import CuratedMasterpieces from '../../components/landing/CuratedMasterpieces';
import FeaturesSection from '../../components/landing/FeaturesSection';
import StatsSection from '../../components/landing/StatsSection';
import HowItWorksSection from '../../components/landing/HowItWorksSection';
import CTASection from '../../components/landing/CTASection';
import '../../styles/Landing.css';

export default function Home() {
  return (
    <div className="landing-page">
      {/* Ambient Global Scroll Progress */}
      <ScrollProgress />

      {/* Hero Section with Parallax Physics & 3D Artwork (Cinematic Obsidian) */}
      <HeroSection />

      {/* Curated Masterpiece Exhibition (70:30 Light Narrative Card / Dark 3D Stage) */}
      <div id="curated-vault">
        <CuratedMasterpieces />
      </div>

      {/* Bento Platform Architecture & Fractional Simulator (70:30 Zig-Zag Bento Cards) */}
      <FeaturesSection />

      {/* Numerical Telemetry & Growth Metrics (70:30 Light/Dark Stat Cards) */}
      <StatsSection />

      {/* Four Steps Scrollytelling Pipeline (70:30 Light/Dark Step Cards) */}
      <HowItWorksSection />

      {/* Institutional Vault WebGL CTA Section (Obsidian Finale) */}
      <CTASection />
    </div>
  );
}